import React from 'react';
import HighlightCard from './HighlightCard';

interface props {
  title: string;
  highlightCardLabel: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const AssessmentInfo = ({ title, highlightCardLabel }: props) => (
  <div className={'mb-md flex items-center'} id='assessment-info-container'>
    <span className={'uppercase italic font-bold md:text-2xl'}>{title}</span>
    <HighlightCard label={highlightCardLabel} highlight />
  </div>
);

AssessmentInfo.displayName = 'AssessmentInfo';

export default AssessmentInfo;
